import { render, staticRenderFns } from "./TeacherMainteTab.vue?vue&type=template&id=6f44d4fa&scoped=true&"
import script from "./TeacherMainteTab.vue?vue&type=script&lang=ts&"
export * from "./TeacherMainteTab.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherMainteTab.vue?vue&type=style&index=0&id=6f44d4fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f44d4fa",
  null
  
)

export default component.exports